import { casinosData } from '../../../mocks/casinos';

export default function ComparisonTable() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50 animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Сравнительная таблица бонусных условий лучших казино онлайн
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Детальное сравнение всех параметров для выбора самого выгодного предложения
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden shadow-xl rounded-2xl border border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gradient-to-r from-orange-500 to-orange-600">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Казино онлайн
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Бонус
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Реальная ценность
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Вейджер
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Мин. депозит
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Сложность
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
                      Рейтинг
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {casinosData.map((casino, index) => (
                    <tr
                      key={casino.id}
                      className={`hover:bg-orange-50 transition-colors duration-200 ${
                        index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                      }`}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-3">
                          <img src={casino.logo} alt={casino.name} className="w-10 h-10 rounded-lg object-contain" />
                          <span className="font-bold text-gray-900">{casino.name}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="font-semibold text-orange-600">{casino.bonus}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="font-bold text-green-600">{casino.realValue}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="font-medium text-gray-900">{casino.wager}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="text-gray-700">{casino.minDeposit}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-3 py-1 rounded-full text-sm font-medium ${
                          casino.difficulty === 'Легко' ? 'bg-green-100 text-green-700' :
                          casino.difficulty === 'Средне' ? 'bg-yellow-100 text-yellow-700' :
                          'bg-red-100 text-red-700'
                        }`}>
                          {casino.difficulty}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-1">
                          <i className="ri-star-fill text-yellow-400"></i>
                          <span className="font-bold text-gray-900">{casino.rating}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-thumb-up-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Легкий отыгрыш</h3>
            <p className="text-gray-600 text-sm">
              Казино онлайн с вейджером x30-x35 и минимальными ограничениями. Идеально для новичков.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-money-dollar-circle-line text-2xl text-orange-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Максимальная выгода</h3>
            <p className="text-gray-600 text-sm">
              Бонусы с наибольшей реальной ценностью после отыгрыша. Лучший выбор для опытных игроков.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
            <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-vip-crown-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">VIP-условия</h3>
            <p className="text-gray-600 text-sm">
              Эксклюзивные бонусы для постоянных игроков с персональным менеджером и ускоренным выводом.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}